<template>
  <tr v-if="item.type === 0 ">
    <td class="group_res" >
      {{ name }}({{ item.online }} / {{ item.count }})
    </td>
  </tr>
  <tr v-else-if="item.type === -1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()" >
    <tr class="link" >
      <td :data-label="translate('simcard_profile.mno')">
        {{ item.mno }}
      </td>

      <td :data-label="translate('simcard_profile.number')">
        {{ item.msisdn }}
      </td>

      <td :data-label="translate('simcard_profile.imsi')">
        {{ item.imsi }}
      </td>

      <td :data-label="translate('simcard_profile.iccid')">
        {{ item.iccid }}
      </td>

      <td :data-label="translate('simcard_profile.tariff')" style="width: 300px">
        {{ simcard_tariff(item.tariff_id) }}
      </td>

      <td :data-label="translate('simcard_profile.type')" style="width: 120px">
        {{ simcard_esim(item.sim_type) }}
      </td>

      <td :data-label="translate('simcard_profile.status')" style="width: 120px">
      <span class="badge" :class="simcard_status_color(+item.status)">
        {{simcard_status_text(+item.status)}}
      </span>
      </td>

      <td :data-label="translate('simcard_profile.ts_update')">
        {{ get_date(item.ts_update) }}
      </td>
    </tr>
  </router-link>

</template>
<script>

export default {
  name: 'SimCardProfileListItem',
  components: {
  },
  props: ['item', 'index', 'checked', 'checkbox', 'groups', 'traffic_list'],
  data () {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    name () {
      if (this.item.type === 0) {
        return this.$store.getters.getSimcardDevicesGroupById(this.item.id).name
      }
      else {
        let name = this.item.name2
        if (this.$store.getters.getPermissions.permissionGod) {
          name += ' / '
          name += this.item.name
        }
        return name
      }
    },
  },
  activated () {
    this.$emit('mount', this.index)
  },
  mounted () {
    this.$emit('mount', this.index)
  },
  methods: {
    simcard_esim(type){
      switch (type) {
        case 0: return 'sim'
        case 1: return 'esim'
      }
    },
    simcard_tariff(id){
      return this.traffic_list[id] ? this.traffic_list[id].tariff_name : ''
    },
    simcard_status_text(status){
      switch (status) {
        case -1: return this.translate('simcard_profile.status_info.undefined')
        case 1: return this.translate('simcard_profile.status_info.active')
        case 2: return this.translate('simcard_profile.status_info.blocked')
        case 3: return this.translate('simcard_profile.status_info.prepare')
        case 4: return this.translate('simcard_profile.status_info.stop')
      }
    },
    simcard_status_color(status){
      switch (status) {
        case -1: return 'gray'
        case 1: return 'green'
        case 2: return 'yellow'
        case 3: return 'blue'
        case 4: return 'red'
      }
    },
    check () {
      this.$emit('check', !this.item.checked, this.item.device_id)
    },
    cntx_menu (e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to () {
      let id = this.item.imsi && String(this.item.imsi).length > 14 ? this.item.imsi : this.item.id
      return {path: 'simcard_profile/' + id}
    },
    ready () {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .error_device {
    font-size: 20px;
    color: #FF0000;
  }
  .group_res{
    cursor: auto;
  }
</style>
